export const statusLabels = {
  draft: "Draft",
  under_review: "Under Review",
  supplier_review: "Supplier Review",
  pending_approval: "Pending Approval",
  approved: "Approved",
  active: "Active",
  expired: "Expired",
  terminated: "Terminated",
  archived: "Archived",
};

export const statusColors = {
  draft: "bg-slate-100 text-slate-700",
  under_review: "bg-amber-100 text-amber-700",
  supplier_review: "bg-indigo-100 text-indigo-700",
  pending_approval: "bg-blue-100 text-blue-700",
  approved: "bg-emerald-100 text-emerald-700",
  active: "bg-cyan-100 text-cyan-700",
  expired: "bg-red-100 text-red-700",
  terminated: "bg-gray-100 text-gray-700",
  archived: "bg-purple-100 text-purple-700",
};

export const formatDate = (dateString) => {
  if (!dateString) return "-";
  return new Date(dateString).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
};

export const formatDateTime = (dateString) => {
  if (!dateString) return "-";
  return new Date(dateString).toLocaleString("en-US", { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
};

export const formatCurrency = (value, ccy) => {
  if (!value) return "-";
  try {
    return new Intl.NumberFormat("en-GB", { style: "currency", currency: ccy || "GBP", minimumFractionDigits: 0 }).format(value);
  } catch {
    return `${ccy || ""} ${Number(value).toLocaleString()}`;
  }
};

export const GDPR_PROTECTED = ["approved", "active", "expired", "terminated"];
export const IN_WORKFLOW = ["under_review", "pending_approval"];
